import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { captureClickIds } from "@/lib/analytics/clickIds";

// Capture paid-attribution click IDs (gclid / fbclid / gbraid / wbraid)
// and UTMs before React renders so the first /api/events POST and the
// booking POST both carry the full attribution blob.
captureClickIds();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
